import React from 'react'
import {Spin, message, Button, Radio, Alert, Popconfirm} from 'antd';
import Lang from "@components/Lang/Lang";
import {symbolMoneyUtil,isEmpty,isEmptyObject} from '@utils/utils';
import ModalConfirmPaymentAction from "./ModalConfirmPayment.action";
import PropTypes from 'prop-types';
import dayjs from "dayjs";
import "./confirmPayment.less"
/**
 * 确认付款 展示
 *
 * @author FJJ
 * @version 1.0
 *
 * History:
 * Date      Version Remarks
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class ConfirmPayment extends React.Component {
    static propTypes = {
        id:  PropTypes.number.isRequired,
    }
    static defaultProps = {
        id:"",
        iTotal:0,
    };
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            list:[],//行
            options : [
                { label: Lang({id:"XianJin",default:"现金"}), value: 'cash' },
                { label: Lang({id:"HuiKuan",default:"汇款"}), value: 'remittance' },
            ], // 	支付方式;现金:cash,汇款:remittance
            values:{
            }
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    //行编
    setValue(field="",value){
        let {values={},errObj={}} = this.state;
        values[field] = value;
        errObj[field] = !value;
        this.setState({
            values:values,
            errObj:errObj
        })
    }
    getValues(){
        const {values={}} = this.state;
        console.log("values",values)
        let errObj = {}
        if(isEmpty(values.payType)){
            errObj["payType"] = true
        }
        if(values.payType=="remittance"&&isEmpty(values.bankCardId)){
            errObj["bankCardId"] = true
        }else if(values.payType=="cash"){
            delete values.bankCardId
        }
        this.setState({
            errObj
        })
        if(isEmptyObject(errObj)){
            return values
        }else {
            return false
        }
    }
    getBankList(){
        this.loading(true);
        ModalConfirmPaymentAction.post('/service/mg/sale/chinaOrder/bankCard/list',{}).then(res => {
            this.loading(false)
            if (res.data.success && res.data.valid) {
                const list = res.data.models || []
                this.setState({
                    list:list
                })
            } else {
                message.info(res.data.message);
            }
        }).catch((err)=>{
            this.loading(false);
            this.setState({
                list:[]
            })
        })
    }
    componentWillMount() {
        this.getBankList()
    }
    componentDidMount() {
        if( this.props.onRef)this.props.onRef(this);
    }
    render() {
        const { iTotal,currencySymbol,orderNumber } = this.props;
        const {loading, options, values={},errObj={},list } = this.state;
        return (<Spin spinning={loading}>
                        <div className="confirmPaymentWrap mt_14 font-14 black89">
                            <div className={"topInfo flex-item-between"}>
                                <div>{orderNumber}</div>
                                <div className={"fw_700 font_16"}>{symbolMoneyUtil(iTotal,currencySymbol)}</div>
                            </div>
                            <div className={"black89 mt_16 mb_4"}>
                                <span className={"color-red2 mr_4"}>*</span>
                                <span className={"fw_700"}>{Lang({id:"QingXuanZeDingDanFuKuanFangShi",default:"请选择订单付款方式"})}</span>
                            </div>
                            <Radio.Group options={options} onChange={(e)=>this.setValue("payType",e.target.value)} value={values.payType} optionType="button" />
                            {errObj.payType&&<p className={"mt_8 mb_8 color-red"}>{Lang({id:"QingXuanZeDingDanFuKuanFangShi",default:"请选择订单付款方式"})}</p>}
                            {values.payType=="remittance"?<>
                                <div className={"black89 mt_16"}>
                                    <span className={"color-red2 mr_4"}>*</span>
                                    <span className={"fw_700"}>{Lang({id:"QingXuanZeDingDanFuKuanKaHao",default:"请选择订单付款卡号"})}</span>
                                </div>
                                <div className={"payCardList mt_4"}>
                                 {list.map((item,inx)=>{
                                     const out = item.balance<iTotal||item.currencySymbol!=currencySymbol;
                                     return (<div key={inx} className={`flex-item-between payCardInfo${values.bankCardId==item.id?" onPay cursor-p":(out?" disabledPay":" cursor-p")}`}
                                                  onClick={()=>out?message.warning(Lang({id:"ChaoChuKeYongEDu",default:"超出可用额度"})):this.setValue("bankCardId",item.id)}>
                                         <div className={"flex-item-ver-center"}>
                                             <i className={"ri-bank-card-fill iconColor font_32"} />
                                             <div className={"ml_12"}>
                                                 <p className={"fw_700 font_16"}>{item.bankCardNo}</p>
                                                 <p className={"fw_500"}>{item.payeeName}</p>
                                                 <p className={"font_12 black66"}>{Lang({id:"LeiJiDing",default:"累计"})}
                                                    <span className={"ml_4"}>{symbolMoneyUtil(item.useBalance,item.currencySymbol)}</span>
                                                 </p>
                                             </div>
                                         </div>
                                         <div className={"text-right"}>
                                             <p className={"font_12 fw_500"}>{Lang({id:"KeYongEDu",default:"可用额度"})}</p>
                                             <p className={"fw_500 font_16"}>{symbolMoneyUtil(item.balance,item.currencySymbol)}</p>
                                         </div>
                                     </div>)
                                 })}
                                </div>
                                {errObj.bankCardId&&<p className={"mt_8 mb_8 color-red"}>{Lang({id:"QingXuanZeDingDanFuKuanKaHao",default:"请选择订单付款卡号"})}</p>}
                            </>:null}
                        </div>
                    </Spin>)
    }
}